import React from 'react';

const Image = (props) => {
  return (
    <img src={ `/images/${ props.featured_image }` } alt={ props.alt_text } />
  );
};

export default Image;




// WEBPACK FOOTER //
// ./app/src/App/components/Image.js